/**
 * Backend URL detection — runtime, hostname-based.
 *
 * Critical fix (2026-02): Le build statiche pubblicate su Hostinger non devono
 * "cuocere" l'URL del backend dal .env di sviluppo. Selezioniamo il backend
 * giusto in base all'hostname effettivo:
 *
 *   installatorilojack.com (+ www.) → https://appoint-track-2.emergent.host  (PROD)
 *   altrimenti                       → process.env.REACT_APP_BACKEND_URL     (PREVIEW/DEV/LOCAL)
 *
 * Cosi' la stessa build puo' essere ospitata ovunque e parlera' sempre col
 * backend corretto.
 */

const PROD_BACKEND = "https://appoint-track-2.emergent.host";
const DEV_BACKEND = process.env.REACT_APP_BACKEND_URL || "";

const isProdHost = () => {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname.toLowerCase();
  return h === "installatorilojack.com" || h === "www.installatorilojack.com";
};

const BACKEND_URL = isProdHost() ? PROD_BACKEND : DEV_BACKEND;

export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };
export default BACKEND_URL;
